'use strict';

const debounce = (ms) => (fn) => {
    let timeout;
    const enhancedFn = ((...args) => {
        if (timeout)
            globalThis.clearTimeout(timeout);
        timeout = globalThis.setTimeout(() => fn(...args), ms);
    });
    return enhancedFn;
};

exports.debounce = debounce;
//# sourceMappingURL=functions.js.map
